import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useStores } from '../../data/store'

const SessionExpire = () => {
  const navigation = useNavigation()

  const { errorMessage, resetMessage } = useStores((store) => ({
    errorMessage: store.message.getMessage(),
    resetMessage: store.message.resetMessage,
  }))

  const [toggle, setToggle] = useState(false)

  const onExpiry = () => {
    const isCitrixIp = localStorage.getItem('isCitrixIp')
    localStorage.clear()
    localStorage.setItem('isCitrixIp', isCitrixIp)
    resetMessage()
    navigation.reset({
      index: 0,
      routes: [{ name: 'login' }],
    })
  }

  useEffect(() => {
    setToggle(errorMessage.value === 'Session Expired, Re-login')
  }, [errorMessage])

  return (
    <ModalAlertView
      onPress={onExpiry}
      show={toggle}
      onDismiss={onExpiry}
      title="Session Expiry"
      buttonTitle="Ok"
      message={'Session is about to expire, re-login'}
    />
  )
}

export { SessionExpire }
